<form #form="ngForm" taxCreditFormValidator>
    <!-- Calendar Year -->
    <mat-form-field *ngIf="!isFederal">
        <mat-label appRemoveAriaOwns>{{
            'employees.jobAndPay.taxCredits.fields.provincial.jurisdiction.label' | translate
        }}</mat-label>
        <mat-select
            #matSelect
            type="text"
            name="jurisdiction"
            [(ngModel)]="taxCredit.jurisdiction"
            required
            (ngModelChange)="selectedJurisdiction.set($event)"
        >
            <mat-option *ngFor="let jurisdiction of jurisdictions" [value]="jurisdiction.value">
                {{ jurisdiction.label | translate }}
            </mat-option>
        </mat-select>
        <mat-hint>{{ 'employees.jobAndPay.taxCredits.fields.provincial.jurisdiction.hint' | translate }}</mat-hint>
    </mat-form-field>
    <!-- Calendar Year -->
    <mat-form-field>
        <mat-label appRemoveAriaOwns>{{
            'employees.jobAndPay.taxCredits.fields.calendarYear.label' | translate
        }}</mat-label>
        <mat-select
            #matSelect
            type="text"
            name="calendarYear"
            [(ngModel)]="taxCredit.year"
            required
            (ngModelChange)="selectedYear.set($event)"
        >
            <mat-option *ngFor="let year of YEAR_RANGES" [value]="year.toString()"> {{ year }} </mat-option>
        </mat-select>
    </mat-form-field>
    <!-- Claim Amount -->
    <mat-form-field *ngIf="taxCredit.jurisdiction && !isQuebec">
        <mat-label>{{
            'employees.jobAndPay.taxCredits.fields.' + (isFederal ? 'federal' : 'provincial') + '.claimAmount.label'
                | translate
        }}</mat-label>
        <input
            name="claimAmount"
            [(ngModel)]="taxCredit.claimAmount"
            [textMask]="{ mask: currencyMask }"
            [placeholder]="PERSONAL_AMOUNT()"
            matInput
        />
        <mat-hint>{{
            {
                key:
                    'employees.jobAndPay.taxCredits.fields.' +
                    (isFederal ? 'federal' : 'provincial') +
                    '.claimAmount.hint',
                params: {
                    line: TD1_LINE_NUMBER[taxCredit.jurisdiction].line,
                    form: TD1_LINE_NUMBER[taxCredit.jurisdiction].form,
                },
            } | appTranslate
        }}</mat-hint>
    </mat-form-field>

    <ng-container [ngTemplateOutlet]="isFederal ? federalFields : provincialFields" />

    <ng-template #federalFields>
        <!-- Additional Tax -->
        <mat-form-field>
            <mat-label>{{
                'employees.jobAndPay.taxCredits.fields.federal.federalAdditionalDeductions.label' | translate
            }}</mat-label>
            <input
                name="federalAdditionalDeductions"
                [(ngModel)]="taxCredit.federalAdditionalDeductions"
                [textMask]="{ mask: currencyMask }"
                placeholder="$"
                matInput
            />
        </mat-form-field>
        <!-- Zone Deduction -->
        <mat-form-field>
            <mat-label>{{
                'employees.jobAndPay.taxCredits.fields.federal.deductionForZone.label' | translate
            }}</mat-label>
            <input
                name="deductionForZone"
                [(ngModel)]="taxCredit.deductionForZone"
                [textMask]="{ mask: currencyMask }"
                placeholder="$"
                matInput
            />
        </mat-form-field>
        <div>
            <h3 class="margin-bottom-1">
                {{ 'employees.jobAndPay.taxCredits.federal.reductionAtSource.header' | translate }}
            </h3>
            {{ 'employees.jobAndPay.taxCredits.federal.reductionAtSource.description' | translate }}
        </div>
        <!-- Annual Deductions -->
        <mat-form-field>
            <mat-label>{{
                'employees.jobAndPay.taxCredits.fields.federal.annualDeductions.label' | translate
            }}</mat-label>
            <input
                name="annualDeductions"
                [(ngModel)]="taxCredit.annualDeductions"
                [textMask]="{ mask: currencyMask }"
                placeholder="$"
                matInput
            />
            <mat-hint>{{ 'employees.jobAndPay.taxCredits.fields.federal.annualDeductions.hint' | translate }}</mat-hint>
        </mat-form-field>
        <!-- Alimony or maintenance Payments -->
        <mat-form-field>
            <mat-label>{{
                'employees.jobAndPay.taxCredits.fields.federal.alimonyPayments.label' | translate
            }}</mat-label>
            <input
                name="alimonyPayments"
                [(ngModel)]="taxCredit.alimonyPayments"
                [textMask]="{ mask: currencyMask }"
                placeholder="$"
                matInput
            />
            <mat-hint>{{ 'employees.jobAndPay.taxCredits.fields.federal.alimonyPayments.hint' | translate }}</mat-hint>
        </mat-form-field>
        <!-- Other Tax Credits -->
        <mat-form-field>
            <mat-label>{{ 'employees.jobAndPay.taxCredits.fields.federal.otherFederal.label' | translate }}</mat-label>
            <input
                name="otherFederal"
                [(ngModel)]="taxCredit.otherFederal"
                [textMask]="{ mask: currencyMask }"
                placeholder="$"
                matInput
            />
            <mat-hint>{{ 'employees.jobAndPay.taxCredits.fields.federal.otherFederal.hint' | translate }}</mat-hint>
        </mat-form-field>
        <!-- Claim Amount -->
        <mat-form-field>
            <mat-label>{{
                'employees.jobAndPay.taxCredits.fields.federal.otherProvincial.label' | translate
            }}</mat-label>
            <input
                name="otherProvincial"
                [(ngModel)]="taxCredit.otherProvincial"
                [textMask]="{ mask: currencyMask }"
                placeholder="$"
                matInput
            />
            <mat-hint>{{ 'employees.jobAndPay.taxCredits.fields.federal.otherProvincial.hint' | translate }}</mat-hint>
        </mat-form-field>
    </ng-template>

    <ng-template #provincialFields>
        <ng-container *ngIf="isQuebec">
            <!-- Personal Tax -->
            <mat-form-field>
                <mat-label>{{
                    'employees.jobAndPay.taxCredits.fields.provincial.personalTax.label' | translate
                }}</mat-label>
                <input
                    name="personalTax"
                    [(ngModel)]="taxCredit.personalTax"
                    [textMask]="{ mask: currencyMask }"
                    [placeholder]="PERSONAL_AMOUNT()"
                    matInput
                />
                <mat-hint>{{
                    'employees.jobAndPay.taxCredits.fields.provincial.personalTax.hint' | translate
                }}</mat-hint>
            </mat-form-field>
            <!-- Career Extension -->
            <mat-form-field>
                <mat-label>{{
                    'employees.jobAndPay.taxCredits.fields.provincial.careerExtension.label' | translate
                }}</mat-label>
                <input
                    name="careerExtension"
                    [(ngModel)]="taxCredit.careerExtension"
                    [textMask]="{ mask: currencyMask }"
                    placeholder="$"
                    matInput
                />
                <mat-hint>{{
                    'employees.jobAndPay.taxCredits.fields.provincial.careerExtension.hint' | translate
                }}</mat-hint>
            </mat-form-field>
            <!-- Additional Tax -->
            <mat-form-field>
                <mat-label>{{
                    'employees.jobAndPay.taxCredits.fields.provincial.quebecAdditionalDeductions.label' | translate
                }}</mat-label>
                <input
                    name="quebecAdditionalDeductions"
                    [(ngModel)]="taxCredit.quebecAdditionalDeductions"
                    [textMask]="{ mask: currencyMask }"
                    placeholder="$"
                    matInput
                />
                <mat-hint>{{
                    'employees.jobAndPay.taxCredits.fields.provincial.quebecAdditionalDeductions.hint' | translate
                }}</mat-hint>
            </mat-form-field>
            <!-- Deductions -->
            <mat-form-field>
                <mat-label>{{
                    'employees.jobAndPay.taxCredits.fields.provincial.deductions.label' | translate
                }}</mat-label>
                <input
                    name="deductions"
                    [(ngModel)]="taxCredit.deductions"
                    [textMask]="{ mask: currencyMask }"
                    placeholder="$"
                    matInput
                />
                <mat-hint>{{
                    'employees.jobAndPay.taxCredits.fields.provincial.deductions.hint' | translate
                }}</mat-hint>
            </mat-form-field>
        </ng-container>
    </ng-template>
</form>
